import {Component, OnInit} from '@angular/core';
import {CollegeInfoService} from '../../services/college-info.service';
import {LangChange} from '../../../../lang-change';
import {Language} from '../../../../common/models/language';
import {TranslateService} from '@ngx-translate/core';
import {Principal} from "../../../../common/services/principal";
import {CommonMainLayoutComponent} from "../common-main-layout/common-main-layout.component";
import {Utils} from "../../../../common/services/Utils";

class OptionsData {
  value: number;
  name: string;
}

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent extends LangChange implements OnInit {

  lang: string;
  regionId: number;

  constructor(private collegeInfoService: CollegeInfoService,
              _translateService: TranslateService,
              private _principal: Principal,
              private commonMainLayoutComponent: CommonMainLayoutComponent,
              private _utils: Utils) {
    super(_translateService);
    this.lang = Language.getCurrentLanguage().code;
    this.regionId = this._utils.getRegionIdByHost();
  }

  ngOnInit() {
    if (!this._principal.isLoggedInFromBackend()) {
      this.commonMainLayoutComponent.initializeAdminPanelLink(true);
    }
  }

  onLangChange(language: Language): void {
    this.lang = language['code'];
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/main/main.component.ts